import { render, staticRenderFns } from "./SelectOrdenes.vue?vue&type=template&id=bdd36964&"
import script from "./SelectOrdenes.vue?vue&type=script&lang=js&"
export * from "./SelectOrdenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports